import { z } from "zod";

import { NIKE_URL } from "@/data/constants/url";

const searchSymbolResponseSchema = z.object({
  data: z.array(
    z.object({
      symbol: z.string(),
      full_name: z.string().nullish(),
      type: z.string().nullish(),
      exchange: z.string().nullish(),
      description: z.string().nullish(),
      exchange_logo: z.string().nullish(),
      logo_urls: z.array(z.string()).nullish(),
    })
  ),
  message: z.string(),
});

export type SearchSymbolsResponse = z.infer<typeof searchSymbolResponseSchema>;
export type SearchSymbolsData = SearchSymbolsResponse["data"];

export const searchSymbols = async ({
  query,
  type,
  limit = 30,
}: {
  query: string;
  type?: string;
  limit?: number;
}): Promise<SearchSymbolsData> => {
  const url = new URL(`${NIKE_URL}/tradingview-chart/search`);
  url.searchParams.set("query", query);
  url.searchParams.set("limit", limit.toString());
  if (type) url.searchParams.set("type", type);
  const res = await fetch(url.toString(), {
    method: "GET",
    cache: "no-cache",
  });

  if (!res.ok) throw new Error(`API failed (${url.toString()})`);
  return searchSymbolResponseSchema.parse(await res.json()).data;
};
